import { Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import ATitle from "core/presentation/components/Title";
import { typography } from "theme/Typography";
import { EyeIcon } from "../../../../../assets/icons/EyeIcon";
import { useAppDispatch, useAppSelector } from "core/presentation/store/hooks";
import Loader from "core/presentation/components/Loader";
import { useNavigate } from "react-router-dom";
import AButton from "core/presentation/components/Button";
import { orderThunks } from "order/presentation/store/orderSlice";
import PaginationTable from "core/presentation/components/PaginationTable";
import { useSelector } from "react-redux";
import { RootState } from "core/presentation/store";

const RecentOrders = () => {
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoading, orderandRequest, orderandRequestCount } = useSelector((state: RootState) => state.order);
  const navigate = useNavigate();

  const getRequest = async (page: number) => {
    await dispatch(
      orderThunks.getRequestAndOrderThunk({
        page: page,
        status: "bidding_in_progress,bidding_accepted,payment_accepted,order_in_progress,pending,completed",
      }),
    );
  };

  useEffect(() => {
    getRequest(1);
  }, [dispatch]);

  const columns: ColumnsType<any> = [
    {
      title: "Request No",
      dataIndex: "requestNumber",
      key: "requestNumber",
    },
    {
      title: "Need No",
      dataIndex: "needNumber",
      key: "needNumber",
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
      key: "vehicleType",
      render: (record: any) => {
        return record?.typeName || "-";
      },
    },
    {
      title: "From",
      dataIndex: "pickup",
      key: "pickup",
      render: (text: any, record: any) => {
        const pickupLocation = record.locationSpecification?.[0]?.pickupLocation?.[0];
        const locationName = [pickupLocation?.streetAddress, pickupLocation?.administrativeDivision?.municipality, pickupLocation?.administrativeDivision?.district, pickupLocation?.administrativeDivision?.state]?.filter(Boolean).join(", ");
        return <div>{locationName}</div>;
      },
    },
    {
      title: "To",
      dataIndex: "drop",
      key: "drop",
      render: (text: any, record: any) => {
        const deliveryLocation = record.locationSpecification?.[0]?.deliveryLocation?.[0];
        const locationName = [deliveryLocation?.streetAddress, deliveryLocation?.administrativeDivision?.municipality, deliveryLocation?.administrativeDivision?.district, deliveryLocation?.administrativeDivision?.state]?.filter(Boolean).join(", ");
        return <div>{locationName}</div>;
      },
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      render: (text: any, record: any) => {
        return <div>{record?.weight ? `${record?.weight} ${record?.unit}` : "--"}</div>;
      },
    },
    {
      title: "Status",
      dataIndex: "requestStatus",
      key: "requestStatus",
      render: (text: any, record: any) => {
        let color;
        switch (record?.status) {
          case "Completed":
            color = "green";
            break;
          case "On-route":
            color = "orange";
            break;
          case "Cancelled":
            color = "red";
            break;
          case "bidding_in_progress":
            color = "blue";
            break;
          default:
            color = "gray";
        }
        return <Tag color={color}>{record?.status}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <AButton
            style={{
              marginTop: "0",
              padding: "5px",
              color: "#F26533",
              fontSize: "14px",
              fontWeight: "600",
            }}
            type="text"
            onClick={() => navigate(`/orders/bid-requests/${record?.vehicleSpecificationId}`)}
          >
            <EyeIcon />
          </AButton>
        );
      },
    },
  ];

  if (isLoading) {
    <Loader />;
  }
  return (
    <>
      <ATitle content={"Recent Orders"} fontSize={typography.fontSizes.lg} fontWeight={600} marginBottom={0} />
      <PaginationTable dataSource={orderandRequest} columns={columns} tableTitle="Recent Orders" totalData={orderandRequestCount} handleChange={getRequest} loading={isLoading} currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </>
  );
};

export default RecentOrders;
